/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'quote-icon-grey': {
    width: 11,
    height: 8,
    viewBox: '0 0 11 8',
    data: '<g _stroke="#A3A3A3" _fill="none" fill-rule="evenodd" stroke-linecap="square" stroke-linejoin="bevel"><path pid="0" d="M3.794 1.285c.536 1.654-.279 2.848-2.444 3.58l2.626 1.99M.912.857h4.815M6.433 3.978h3.703M8.284 2.126V5.83"/></g>'
  }
})
